<template>
  <qx-card-form title="基础信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="140px"
    >
      <p slot="loginAcctTip" class="warning" v-show="otherFormData.serverInfo.info === 2">
        <i class="el-icon-warning error" />
        该服务商已经注册，您可以勾选下方他提供的后服产品申请与合作，服务商审核通过后，将出现在您的后服产品中。
      </p>
      <span class="tip" slot="realAuthTypeTip">
        <el-tooltip content="需要开票的供应商,应该选择企业类型">
          <i class="el-icon-question warning"></i>
        </el-tooltip>
      </span>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  domain,
} from '@/config';
import {
  getEnumList,
} from 'api';
import {
  servicerCheck,
} from 'api/service';
export default {
  data () {
    return {
      otherFormData: {
        serverInfo: {},
      },
      baseForm: {
        serviceTypeOptions: [], // 账号类型
        stateOptions: [], // 账号状态
        realAuthTypeOptions: [
          {
            label: '个人',
            value: '1',
          },
          {
            label: '企业',
            value: '2',
          },
        ],
        form: [
          {
            label: '手机账号',
            value: 'loginAcct',
            type: 'input',
            disabled: false,
            onChange: () => {
              this.handleLoginAcct();
            },
          },
          {
            label: '服务商名称',
            value: 'serviceName',
            type: 'input',
            disabled: false,
          },
          {
            label: '账号类型',
            value: 'serviceType',
            type: 'select',
            onChange: () => {
              this.handleServiceTypeChange();
            },
            disabled: false,
          },
          {
            label: '公司地址',
            value: 'companyAddress',
            type: 'input',
            disabled: false,
          },
          {
            label: '实名认证方式',
            value: 'realAuthType',
            type: 'select',
            onChange: () => {
              this.handleRealTypeChange();
            },
            disabled: false,
            hide: false,
          },
          {
            label: '负责人',
            value: 'linkman',
            type: 'input',
            disabled: false,
            hide: false,
          },
          // 个人
          {
            label: '身份证号',
            value: 'identification',
            type: 'input',
            hide: true,
            disabled: false,
          },
          {
            label: '身份证头像面',
            value: 'idenPictureFrontFile',
            type: 'img',
            width: '200px',
            url: domain + '/oms/file/upload',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            hide: true,
            disabled: false,
          },
          {
            label: '身份证国徽面',
            value: 'idenPictureBackFile',
            type: 'img',
            width: '200px',
            url: domain + '/oms/file/upload',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            hide: true,
            disabled: false,
          },
          // 个人 end
          {
            label: '统一社会信用代码',
            value: 'creditCode',
            type: 'input',
            hide: true,
            disabled: false,
          },
          {
            label: '营业执照',
            value: 'creditPicFile',
            type: 'img',
            width: '200px',
            url: domain + '/oms/file/upload',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            hide: true,
            disabled: false,
          },
          {
            label: '账号状态',
            value: 'state',
            type: 'select',
            hide: true,
          },
        ],
        rules: {
          loginAcct: [ // 手机账号
            { required: true, message: '请输入手机账号', trigger: 'blur' },
          ],
          serviceName: [ // 服务商名称
            { required: true, message: '请输入服务商名称', trigger: 'blur' },
          ],
          serviceType: [ // 账号类型
            { required: true, message: '请选择账号类型', trigger: 'blur' },
          ],
          // companyAddress: [ // 公司地址
          //   { required: true, message: '请输入公司地址', trigger: 'blur' },
          // ],
          realAuthType: [ // 实名认证方式
            { required: true, message: '请选择实名认证方式', trigger: 'blur' },
          ],
          // linkman: [ // 负责人
          //   { required: true, message: '请输入负责人', trigger: 'blur' },
          // ],
          // identification: [ // 身份证号
          //   { required: true, message: '请输入身份证号', trigger: 'blur' },
          // ],
          // idenPictureFrontFile: [ // 身份证头像面
          //   { required: true, message: '请选择身份证头像面', trigger: 'blur' },
          // ],
          // idenPictureBackFile: [ // 身份证国徽面
          //   { required: true, message: '请选择身份证国徽面', trigger: 'blur' },
          // ],
          // creditCode: [ // 统一社会信用代码
          //   { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          // ],
          // creditPicFile: [ // 营业执照
          //   { required: true, message: '请选择营业执照', trigger: 'blur' },
          // ],
        },
      },
    };
  },
  methods: {
    async handleLoginAcct () { // 手机账号
      if (this.$route.query.id) {
        return;
      }
      const loginAcct = this.$refs.baseForm.getVal('loginAcct');
      if (!loginAcct) {
        return;
      }
      if (loginAcct.length !== 11) {
        this.$message.warning('请输入正确的手机号');
        return;
      }
      const res = await servicerCheck({
        loginAcct,
        dateTime: new Date().getTime(),
      });
      this.otherFormData.serverInfo = res;
      this.handleServerAsset();
    },
    handleServerAsset () {
      this.$emit('getOtherFormVal', {
        from: 'apply',
        tar: 'baseForm',
      });
      const serverInfo = this.otherFormData.serverInfo;
      if (serverInfo.info === 2) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: [
            'realAuthType', 'identification', 'idenPictureFrontFile', 'idenPictureBackFile',
            'creditCode', 'creditPicFile',
          ],
        });
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: [
            'realAuthType',
          ],
        });
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: serverInfo.info === 2,
        names: [
          'serviceName', 'serviceType', 'companyAddress', 'linkman',
        ],
      });
      if (serverInfo.info === 2) {
        this.handleRealAuthInfo(serverInfo);
        if (serverInfo.serviceType) { // 账号类型
          serverInfo.serviceType = String(serverInfo.serviceType);
        }
        this.$refs.baseForm.setVal(serverInfo);
      } else {
        // this.$refs.baseForm.setVal('serviceName', '');
        // this.$refs.baseForm.setVal('serviceType', '');
        // this.$refs.baseForm.setVal('companyAddress', '');
        // this.$refs.baseForm.setVal('linkman', '');
      }
    },
    handleServiceTypeChange () { // 账号类型
      this.$emit('getOtherFormVal', {
        from: 'settlement',
        tar: 'baseForm',
      });
    },

    handleRealTypeChange () { // 实名认证方式
      const realAuthType = this.$refs.baseForm.getVal('realAuthType');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: realAuthType !== '1',
        names: ['identification', 'idenPictureFrontFile', 'idenPictureBackFile'],
      });
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: realAuthType !== '2',
        names: ['creditCode', 'creditPicFile'],
      });
    },

    async getList () {
      const enumsList = await getEnumList({
        codeType: 'SYS_SERVICE_BUSI_TYPE,SYS_STATE_DESC',
      });
      this.baseForm.serviceTypeOptions = enumsList[0];
      this.baseForm.stateOptions = enumsList[1];
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        if (formData.idenPictureFrontFile[0]) { // 身份证头像面
          formData.idenPictureFront = formData.idenPictureFrontFile[0].id;
          formData.idenPictureFrontUrl = formData.idenPictureFrontFile[0].url;
          delete formData.idenPictureFrontFile;
        }
        if (formData.idenPictureBackFile[0]) { // 身份证国徽面
          formData.idenPictureBack = formData.idenPictureBackFile[0].id;
          formData.idenPictureBackUrl = formData.idenPictureBackFile[0].url;
          delete formData.idenPictureBackFile;
        }
        if (formData.creditPicFile[0]) { // 营业执照
          formData.idenPictureFront = formData.creditPicFile[0].id;
          formData.idenPictureFrontUrl = formData.creditPicFile[0].url;
          delete formData.creditPicFile;
        }
        if (String(formData.realAuthType) !== '1') { // 个人
          formData.identification = formData.creditCode;
          delete formData.creditCode;
        }
      }
      return formData;
    },

    async sub () {
      let formData = await this.handleSubData();
      if (formData) {
        formData = {
          ...this.otherFormData.serverInfo,
          ...formData,
        };
      }
      return formData;
    },
    async cacheData () {
      const res = await this.handleSubData(true);
      return {
        ...res,
        serverInfo: this.otherFormData.serverInfo,
      };
    },
    handleRealAuthInfo (data) {
      if (String(data.realAuthType) === '1') { // 个人
        if (data.idenPictureFront) { // 身份证头像面
          data.idenPictureFrontFile = [{
            id: data.idenPictureFront,
            url: data.idenPictureFrontUrl,
          }];
        } else {
          data.idenPictureFrontFile = [];
        }
        if (data.idenPictureBack) { // 身份证国徽面
          data.idenPictureBackFile = [{
            id: data.idenPictureBack,
            url: data.idenPictureBackUrl,
          }];
        } else {
          data.idenPictureBackFile = [];
        }
        data.creditPicFile = []; // 营业执照
      } else { // 企业
        data.creditCode = data.identification;
        data.idenPictureFrontFile = []; // 身份证头像面
        data.idenPictureBackFile = []; // 身份证国徽面
        if (data.idenPictureFront) { // 营业执照
          data.creditPicFile = [{
            id: data.idenPictureFront,
            url: data.idenPictureFrontUrl,
          }];
        } else {
          data.creditPicFile = [];
        }
      }
    },
    init (data = {}) {
      if (data.serviceType) { // 账号类型
        data.serviceType = String(data.serviceType);
      }
      if (data.realAuthType) { // 实名认证方式
        data.realAuthType = String(data.realAuthType);
      }
      if (data.state) { // 账号状态
        data.state = String(data.state);
      }
      // 账户状态
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !this.$route.query.id,
        names: ['state'],
      });
      this.handleRealAuthInfo(data);
      this.$refs.baseForm.setVal('form', data);
      if (!data.serverInfo) {
        data.serverInfo = {};
      }
      this.setFormVal(this.otherFormData, data);
      this.handleServerAsset();
      this.handleServiceTypeChange();
      this.handleRealTypeChange();
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: Boolean(this.$route.query.id),
        names: [
          'loginAcct', 'serviceName', 'serviceType',
          'companyAddress', 'realAuthType', 'linkman',
          'identification', 'idenPictureFrontFile',
          'idenPictureBackFile', 'creditCode', 'creditPicFile',
        ],
      });
    },
  },
};
</script>

<style scoped lang="scss">
.tip{
  margin-left: 16px;
  color: #999;
  span{
    color: #666;
    margin-right: 8px;
  }
}
</style>
